// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"669":"e7d5eace","787":"4eab6a7f"}[chunkId] + ".chunk.js";
};